import { Avatar as AvatarPrimitive } from 'radix-ui';
import { cn } from '../lib/utils.js';

/** @param {import('react').ComponentProps<typeof AvatarPrimitive.Root>} props */
export function Avatar({ className, ...props }) {
  return <AvatarPrimitive.Root data-slot="avatar" className={cn('relative flex size-8 shrink-0 overflow-hidden rounded-full', className)} {...props} />;
}

/** @param {import('react').ComponentProps<typeof AvatarPrimitive.Image>} props */
export function AvatarImage({ className, ...props }) {
  return <AvatarPrimitive.Image data-slot="avatar-image" className={cn('aspect-square size-full', className)} {...props} />;
}

/** @param {import('react').ComponentProps<typeof AvatarPrimitive.Fallback>} props */
export function AvatarFallback({ className, ...props }) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn('flex size-full items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary', className)}
      {...props}
    />
  );
}

/** "Erika Mustermann" → "EM" */
export function initials(name = '') {
  return (
    name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase())
      .join('') || '?'
  );
}
